import { render, staticRenderFns } from "./SelectProofPayment.vue?vue&type=template&id=fd7cdd1e&"
import script from "./SelectProofPayment.vue?vue&type=script&lang=js&"
export * from "./SelectProofPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports